import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRepeatOrder from './repeat-order.reducer';
import { State } from '@cemex/cmx-client-layout';

export const repeatOrderKey = 'RepeatOrder';

export interface IRepeatOrderMainState {
  repeatOrderState: fromRepeatOrder.IRepeatOrderState;
}

export interface RepeatOrderFeatureState extends State {
  repeatOrderState: IRepeatOrderMainState;
}

export const reducers: ActionReducerMap<IRepeatOrderMainState> = {
  repeatOrderState: fromRepeatOrder.reducer,
};
export const getRepeatOrderMainState = createFeatureSelector<IRepeatOrderMainState>(repeatOrderKey);
export const getRepeatOrderState = createSelector(getRepeatOrderMainState, state => state.repeatOrderState);
